import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DatetimePickerComponent } from './components/datetime-picker/datetime-picker.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
//import { NgBootstrapDatetimeAngularModule } from "ng-bootstrap-datetime-angular";
import { TreeViewComponent } from './components/tree-view/tree-view.component';
import { TreeviewModule } from 'ngx-treeview';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { AgmCoreModule } from '@agm/core';
import { TableModule } from 'primeng/table';
import { ContextMenuModule } from 'primeng/contextmenu';
import { CardModule } from 'primeng/card';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import {DialogModule} from 'primeng/dialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import {MultiSelectModule} from 'primeng/multiselect';
import {ButtonModule} from 'primeng/button';
import {ToolbarModule} from 'primeng/toolbar';
import {InputTextModule} from 'primeng/inputtext';
import {CheckboxModule} from 'primeng/checkbox';
import {DropdownModule} from 'primeng/dropdown';
import { BytesPipe, NgPipesModule } from 'ngx-pipes';
import {NgJsonEditorModule} from 'ang-jsoneditor';
import {JsonDiffComponent } from './components/json-diff/json-diff.component';
import { CalendarModule } from 'primeng/calendar';
import { PGroupMultiselectComponent } from './components/p-group-multiselect/p-group-multiselect.component';
import {RadioButtonModule} from 'primeng/radiobutton';
import { MultiselectProjectLabelsPipe } from './pipes/multiselect-project-labels.pipe';
import {TooltipModule} from 'primeng/tooltip';
import { ParseTimezonesPipe } from './pipes/parse-timezones.pipe';
import {ProgressBarModule} from 'primeng/progressbar';
import {FileUploadModule} from 'primeng/fileupload';
import {TreeModule} from 'primeng/tree';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import {PanelModule} from 'primeng/panel';
import { ParseUrlDateStringToDatePipe } from './pipes/parse-url-date-string-to-date.pipe';
import { HighchartsChartModule } from 'highcharts-angular';
import { MarkdownModule } from 'ngx-markdown';
import { DecimalNumberDirective } from './directives/decimal-number.directive';
import { LocaleDateTimeComponent } from './components/locale-date-time/locale-date-time.component';
import { LocalizedDatePipe } from './pipes/localized-date.pipe';
import { ElapsedTimePipe } from './pipes/elapsed-time.pipe';

@NgModule({
  declarations: [DatetimePickerComponent, DatePickerComponent, TreeViewComponent, ConfirmationDialogComponent, JsonDiffComponent, PGroupMultiselectComponent, MultiselectProjectLabelsPipe, ParseTimezonesPipe, ParseUrlDateStringToDatePipe, DecimalNumberDirective, LocaleDateTimeComponent,  LocalizedDatePipe, ElapsedTimePipe],
  imports: [
   BrowserAnimationsModule,
   CommonModule,
   FormsModule,
   ReactiveFormsModule,
   NgbModule,
   TreeviewModule.forRoot(),
   TranslateModule,
   GoogleMapsModule,
   AgmCoreModule,
   TableModule,
   ContextMenuModule,
   CardModule,
   MessageModule,
   MessagesModule,
   ToastModule,
   DynamicDialogModule,
   MultiSelectModule,
   ButtonModule,
   ToolbarModule,
   DialogModule,
   InputTextModule,
   CheckboxModule,
   DropdownModule,
   NgPipesModule,
   NgJsonEditorModule,
   CalendarModule,
   RadioButtonModule,
   TooltipModule,
   ProgressBarModule,
   FileUploadModule,
   TreeModule,
   OverlayPanelModule,
   ConfirmDialogModule,
   ToastModule,
   PanelModule,
   HighchartsChartModule,
   MarkdownModule.forRoot()
  ],
  exports: [
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    TreeviewModule, 
    TranslateModule,
    GoogleMapsModule,
    AgmCoreModule,
    DatetimePickerComponent,
    TableModule,
    ContextMenuModule,
    CardModule,
    MessageModule,
    MessagesModule,
    ToastModule,
    DynamicDialogModule,
    MultiSelectModule,
    ButtonModule,
    ToolbarModule,
    DialogModule,
    InputTextModule,
    CheckboxModule,
    DropdownModule,
    NgPipesModule,
    NgJsonEditorModule,
    JsonDiffComponent,
    CalendarModule,
    RadioButtonModule,
    PGroupMultiselectComponent,
    TooltipModule,
    ProgressBarModule,
    DatePickerComponent,
    FileUploadModule,
    TreeModule,
    OverlayPanelModule,
    ConfirmDialogModule,
    ParseTimezonesPipe,
    PanelModule,
    HighchartsChartModule,
    MarkdownModule,
    DecimalNumberDirective,
    LocaleDateTimeComponent,
    ElapsedTimePipe
  ],
  providers: [DatePipe, ParseUrlDateStringToDatePipe, DecimalPipe, BytesPipe],
  entryComponents: [
    DatetimePickerComponent, DatePickerComponent, TreeViewComponent, ConfirmationDialogComponent
  ]
})
export class SharedModule { }
